import { useUnit } from 'effector-react';
import { useEffect } from 'react';
import { $mapLoaded } from '../../models/mapModel/index.js';
import { $activeMetric, $floodsArea } from '../../models/logicModel/index.js';
import { changeLayerVisibility } from '../../utils/mapbox-utils.js';

const gradientProp = [
  'case',
  ['all', ['==', ['get', 'index'], 1]],
  '#E3F2FD',
  ['all', ['==', ['get', 'index'], 2]],
  '#BBDEFB',
  ['all', ['==', ['get', 'index'], 3]],
  '#90CAF9',
  ['all', ['==', ['get', 'index'], 4]],
  '#64B5F6',
  ['all', ['==', ['get', 'index'], 5]],
  '#42A5F5',
  ['all', ['==', ['get', 'index'], 6]],
  '#2196F3',
  ['all', ['==', ['get', 'index'], 7]],
  '#1E88E5',
  ['all', ['==', ['get', 'index'], 8]],
  '#1976D2',
  ['all', ['==', ['get', 'index'], 9]],
  '#1565C0',
  ['all', ['==', ['get', 'index'], 10]],
  '#0D47A1',
  'rgba(0,0,0,0.7)',
];

function FloodsLayer() {
  const mapLoaded = useUnit($mapLoaded);
  const polygons = useUnit($floodsArea);
  const acitveMetric = useUnit($activeMetric);

  const createLayer = (update) => {
    const floodData = {
      type: 'FeatureCollection',
      features: polygons,
    };

    if (update) {
      window.map.getSource('un_floods_source').setData(floodData);
    } else {
      if (!window.map.getSource('un_floods_source')) {
        window.map.addSource('un_floods_source', {
          type: 'geojson',
          data: floodData,
        });
      }

      if (!window.map.getLayer('un_floods_layer')) {
        window.map.addLayer({
          id: 'un_floods_layer',
          type: 'fill',
          source: 'un_floods_source',
          paint: {
            'fill-color': gradientProp,
            'fill-opacity': 0.5,
          },
        });

        window.map.addLayer({
          id: 'un_floods_outline',
          type: 'line',
          source: 'un_floods_source',
          paint: {
            'line-color': gradientProp,
            'line-width': 1,
          },
        });
      }

      changeLayerVisibility('un_floods_layer', false);
      changeLayerVisibility('un_floods_outline', false);
    }
  };

  useEffect(() => {
    if (mapLoaded && polygons.length > 0) {
      if (window.map.getLayer('un_floods_layer')) {
        createLayer(true);
      } else {
        setTimeout(() => {
          createLayer(false);
        }, 500);
      }
    }
  }, [mapLoaded, polygons]);

  useEffect(() => {
    if (mapLoaded) {
      if (window.map.getLayer('un_floods_layer')) {
        if (acitveMetric === 'flood_ind') {
          changeLayerVisibility('un_floods_layer', true);
          changeLayerVisibility('un_floods_outline', true);
        } else {
          changeLayerVisibility('un_floods_layer', false);
          changeLayerVisibility('un_floods_outline', false);
        }
      }
    }
  }, [mapLoaded, acitveMetric]);

  return null;
}

export default FloodsLayer;
